export default __webpack_public_path__ + "static/media/100_38812.cc259b8f.jpg";